import React from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';
import { AmountCurrencyInputAdornment } from './AmountCurrencyInputAdornment';
import { valueAsExpense } from '../../Utils/ValueAsUtils';

const PaymentAmount = (props) => {
    const { disabled, index, expense, isViewOnly } = props;
    const { control, errors } = useFormContext();

    return (
        <Grid2 item size={4}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].amount`}
                defaultValue={expense.amount}
                rules={{
                    required: 'Amount is required',
                    max: {
                        value: 99999.99,
                        message: "Amount can't exceed 99,999.99",
                    },
                }}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        required
                        placeholder="0.00"
                        id="payment-amount"
                        onChange={(e) => onChange(valueAsExpense(e.target.value))}
                        value={value}
                        label="Amount"
                        endAdornment={
                            <AmountCurrencyInputAdornment
                                disabled={disabled || isViewOnly}
                                index={index}
                                currencyType={expense.currency}
                                name={`expenseEntries[${index}].paymentCurrency`}
                            />
                        }
                        error={Boolean(errors.expenseEntries?.[index]?.amount)}
                        disabled={isViewOnly}
                        helperText={errors.expenseEntries?.[index]?.amount?.message}
                    />
                )}
            />
        </Grid2>
    );
};

export default PaymentAmount;
